import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./TagResourceV3.scss";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import { colors } from "Constants";
import { getOrganizationAssessmentsQuery } from "Post/modules/PostQuery";

import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import ConditionalWrapper from "Utils/ConditionalWrapper";

import { updatePost } from "Post/modules/PostModule";
import { getFieldUids } from "modules/TaggableElementsUtils";

import { pypElementMapping } from "Constants/plannerElementMappings";
import { getCurrentAcademicYear } from "modules/CommonSelectors";

import moment from "moment";

import ResourceList from "./ResourceList";
import { Button, Modal, Tooltip, SearchInput } from "@toddle-edu/ds-web";
import {
  checkScrollAtBottom,
  isTablet,
  isTabletByUserAgent,
  scrollIntoView,
} from "Utils";
import {
  getIsNewGoalTaggingEnabled,
  getIsNewGradingSetupEnabled,
  getPostEntity,
  isAssessmentTagged,
  isUnitPlanOrAssessmentTagged,
} from "Post/utils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getIsSubjectStandard } from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/utils";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";

const BLANK_OBJECT = {};
const BLANK_ARRAY = [];
const styles = {
  titleTextStyle: {
    fontSize: "1.8rem",
    alignItems: "center",
  },
  titleContainerStyle: { marginTop: "32px" },
  containerStyle: { padding: "0 32px" },
  modalHeader: {
    display: "flex",
    width: "100%",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalBody: {
    overflowX: "hidden",
    overflowY: "auto",
    borderBottom: ` 1px solid ${colors.strokeTwo}`,
  },
  modalBodyDivider: {
    marginTop: "16px",
    borderTop: ` 1px solid ${colors.strokeTwo}`,
  },
  borderNoneTablet: { border: "none" },
  leLabel: { color: "var(--text-secondary)", marginLeft: "2px" },
  headerStyle: {
    display: "flex",
    flexDirection: "column",
  },
  footerContainerStyle: {
    paddingTop: "16px",
  },
};

const getStandardSetIds = (entities, isPYPCurriculum) => {
  const nestedStandardSetIds = _.map(entities, standardEntity => {
    if (
      standardEntity &&
      _.isArray(standardEntity.value) &&
      !_.isEmpty(standardEntity.value)
    ) {
      return _.map(
        isPYPCurriculum
          ? _.get(standardEntity, "resolvedMinimalTree.benchmarks", [])
          : _.get(standardEntity, "resolvedMinimalTree.nodes", []),
        "standardsWrapper.standardSet.id"
      );
    }
    return [];
  });
  // Flatten and remove duplicates/nulls
  return _.uniq(_.flatten(nestedStandardSetIds));
};

const FooterComponent = React.memo(props => {
  const { onNextClick, isDisabled, onBackClick, t } = props;
  return (
    <div className={classes.footerButtonContainer}>
      <Button
        size={"large"}
        onClick={onBackClick}
        variant="outlined-subtle"
        style={{ marginRight: "12px" }}
      >
        {t("common:previous")}
      </Button>
    </div>
  );
});

FooterComponent.displayName = "FooterComponent";
const ITEMS_TO_LOAD = window.innerHeight > 900 ? 22 : 18;
class TagResource extends React.PureComponent {
  constructor(props) {
    super(props);

    this.resourceListRef = React.createRef(null);
    this.tagLearningGoalsButton = React.createRef(null);
    this.selectLearningGoalsButton = React.createRef(null);
    this.containerRef = React.createRef(null);

    this.updatedResourceId = _.get(
      _.first(
        getPostEntity(
          _.get(props, "screenPanelProps.postDetails.postTaggedEntity"),
          "ASSESSMENT"
        )
      ),
      "id"
    );
    this.state = {
      refreshing: false,
      resourceId: getIsNewGoalTaggingEnabled()
        ? this.updatedResourceId
        : props.resourceId,
      resourceType: props.resourceType,
      isResourceSkipped: props.isResourceSkipped,
      searchText: "",
      isTagLearningGoalsEnabled: false,
    };
  }

  stopPropagationAndPreventDefault = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  handleKeyDown = e => {
    const { key } = e;
    if (key === "Tab" && this.leItems?.includes(document.activeElement)) {
      this.stopPropagationAndPreventDefault(e);
      if (this.state.isTagLearningGoalsEnabled) {
        this.tagLearningGoalsButton?.current?.focus();
      } else {
        this.selectLearningGoalsButton?.current?.focus();
      }
    }
  };

  getGoalsAndStudentCount = resource => {
    return _.reduce(
      _.get(resource, "fields", []),
      (acc, element) => {
        const count = _.isArray(_.get(element, "value"))
          ? _.get(element, "value.length", 0)
          : 0;
        return acc + count;
      },
      0
    );
  };

  componentDidMount() {
    if (getIsNewGoalTaggingEnabled() && this.state.resourceId) {
      this.enableTagLearningGoals(this.state.resourceId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.resourceListRef?.current) {
      const leItems =
        Array.from(
          this.resourceListRef?.current?.querySelectorAll(
            ".ResourceList__singleItemContainer___ob1nk"
          )
        ) ?? [];
      if (this.containerRef) {
        this.containerRef.current?.addEventListener(
          "keydown",
          this.handleKeyDown
        );
      }
      this.leItems = leItems;
    }

    if (prevState.resourceId !== this.state.resourceId) {
      this.enableTagLearningGoals(this.state.resourceId);
    }
  }

  componentWillUnmount() {
    const { updatePost } = this.props;
    updatePost({ isMagicWandClick: false });
  }

  onNextClick = (shouldGotoNextScreen = true) => {
    const {
      screenPanelProps: {
        goToNextScreen,
        onCloseClick,
        postDetails: {
          isResourceSkipped: propIsResourceSkipped,
          resourceItem: propResourceItem,
          elementPYP: propElementPYP,
          originalElementPYP = undefined,
          originalResourceItem = {},
          postTaggedEntity = [],
        },
      },
      setToastMsg,
      resources,
      curriculumProgramType,
    } = this.props;

    const { resourceId, isResourceSkipped } = this.state;
    const resourceItem = _.find(resources, item => item.id == resourceId);

    //first check if resourceItem exists and is equal
    let updatedElementPYP = [];
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();

    const isNewGradingSetupEnabled = getIsNewGradingSetupEnabled();
    const standardSetIds = isNewGradingSetupEnabled
      ? getStandardSetIds(
          _.filter(_.get(resourceItem, "fields", []), field =>
            getIsSubjectStandard({ type: pypElementMapping[field?.uid] })
          ),
          curriculumProgramType === CURRICULUM_TYPE_PYP
        )
      : BLANK_ARRAY;
    if (isResourceSkipped) {
      if (propIsResourceSkipped) {
        updatedElementPYP = _.cloneDeep(propElementPYP);
      } else {
        updatedElementPYP = undefined;
      }
    } else {
      const propResourceFromTaggedElements = _.first(
        getPostEntity(postTaggedEntity, "ASSESSMENT")
      );
      if (
        (!isNewGoalTaggingEnabled &&
          (propResourceItem == undefined ||
            (resourceItem != undefined &&
              (resourceItem.id != propResourceItem.id ||
                resourceItem.type != propResourceItem.type)))) ||
        (isNewGoalTaggingEnabled &&
          (_.isEmpty(propResourceFromTaggedElements) ||
            (resourceItem != undefined &&
              (resourceItem.id != propResourceFromTaggedElements.id ||
                resourceItem.type != propResourceFromTaggedElements.type))))
      ) {
        updatedElementPYP = undefined;
      } else {
        updatedElementPYP = _.cloneDeep(propElementPYP);
      }
    }
    if (getIsNewGoalTaggingEnabled()) {
      const updatedPostTaggedEntity = [
        {
          entityType: "ASSESSMENT",
          entity: resourceItem,
          id: resourceId,
        },
      ];
      if (_.get(resourceItem, "unitPlan.id")) {
        updatedPostTaggedEntity.push({
          entityType: "UNIT_PLAN",
          entity: _.get(resourceItem, "unitPlan"),
          id: _.get(resourceItem, "unitPlan.id", null),
        });
      }
      this.props.updatePost({
        postTaggedEntity: updatedPostTaggedEntity,
        elementPYP: updatedElementPYP,
        ...(!shouldGotoNextScreen
          ? { selectedElementsPYP: undefined }
          : BLANK_OBJECT),
        isResourceSkipped,
        selectFromAllPYP: false,
        standardSetIds,
      });
      if (!shouldGotoNextScreen) {
        setToastMsg({
          msg: "journal:le_tagged",
          type: "success",
        });
      }
    } else {
      this.props.updatePost({
        elementPYP: _.isEqual(
          _.get(resourceItem, "id", null),
          _.get(originalResourceItem, "id", null)
        )
          ? originalElementPYP
          : updatedElementPYP,
        resourceItem: resourceItem,
        resourceType: _.get(resourceItem, "type", "ASSESSMENT"),
        isResourceSkipped,
        unitPlan: _.find(
          _.get(this.props, "courseUnitPlans", []),
          unit => unit?.id == _.get(resourceItem, "unitPlan.id", null)
        ),
      });
    }
    shouldGotoNextScreen ? goToNextScreen() : onCloseClick();
  };

  skipResource = () => {
    this.setState({
      isResourceSkipped: !this.state.isResourceSkipped,
      resourceId: null,
      resourceType: null,
    });
  };

  onResourceClicked = resource => {
    const { resourceId } = this.state;
    const { updatePost } = this.props;

    this.setState({
      resourceId: resource.id,
      resourceType: resource.type,
      isResourceSkipped: resource.id == resourceId,
    });
    if (getIsNewGoalTaggingEnabled() && resource.id != resourceId) {
      updatePost({ selectedElementsPYP: null });
    }
    updatePost({
      isWorksheetSelected:
        _.get(resource, "assessmentType.value") === "worksheet",
    });
  };

  enableTagLearningGoals = resourceId => {
    const resource = _.find(
      this.props.resources,
      item => item.id == resourceId
    );
    this.setState({
      isTagLearningGoalsEnabled: this.getGoalsAndStudentCount(resource) > 0,
    });
  };

  handleScroll = e => {
    const containerDiv = e.target;
    const {
      hasNextPage,
      isLoading,
      loadMoreAssessments,
      selectedUnitPlan,
    } = this.props;
    if (
      containerDiv &&
      hasNextPage &&
      isLoading == false &&
      checkScrollAtBottom(containerDiv) &&
      _.size(selectedUnitPlan, 0) > 0
    ) {
      loadMoreAssessments();
    }
  };

  render() {
    const {
      screenPanelProps,
      resources,
      isLoading,
      isData,
      t,
      assessmentCount,
      leCount,
      searchText,
      curriculumProgramType,
      unitPlanOptions,
      selectedUnitPlan,
      onUnitPlanFilterChanged,
      networkStatus,
      isMagicWandClick,
    } = this.props;
    const {
      isResourceSkipped,
      resourceType,
      resourceId,
      postDetails,
    } = this.state;
    const unitPlanOptionsLength = _.get(unitPlanOptions, "length", 0);
    const { onCloseClick } = screenPanelProps;
    const { isTagLearningGoalsEnabled } = this.state;

    const getTagLearningGoalsTooltip = () => {
      if (!resourceId) {
        return t("journal:select_le_to_tag_goals");
      } else if (!isTagLearningGoalsEnabled) {
        return t("journal:no_learning_goals_present");
      }
    };
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();

    const onCloseLEModal = () => {
      const { postTaggedEntity, elementPYP, updatePost } = this.props;

      if (
        isNewGoalTaggingEnabled &&
        isUnitPlanOrAssessmentTagged(postTaggedEntity)
      ) {
        updatePost({ selectedElementsPYP: undefined });
      }
      onCloseClick();
    };

    return (
      <Modal
        dsVersion={"2.0"}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        hasOverlay={true}
        onClose={onCloseLEModal}
        width={isTablet() || isTabletByUserAgent() ? "92%" : "90%"}
        height="90%"
        isCloseable={true}
        isBodyScrollable={false}
      >
        <Modal.Header style={{ paddingBottom: "0px" }}>
          <div style={styles.modalHeader}>
            <div style={styles.headerStyle} className={"heading-4"}>
              {isNewGoalTaggingEnabled
                ? t("journal:tag_learning_elements")
                : t("journal:select_le_or_assessment")}
              <span className="text-label-l" style={styles.leLabel}>
                {t("journal:learning_experience")}
              </span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body
          style={{
            ...styles.modalBody,
            ...(isNewGoalTaggingEnabled
              ? styles.modalBodyDivider
              : BLANK_OBJECT),
            ...(isTablet() || isTabletByUserAgent()
              ? styles.borderNoneTablet
              : BLANK_OBJECT),
          }}
        >
          {(!_.isEmpty(_.get(this.props, "searchText", "")) || isData) && (
            <div className={classes.filterContainer}>
              <SearchInput
                dsVersion="2.0"
                id="search-le"
                value={_.get(this.props, "searchText", "")}
                placeholder={t("common:search_placeholder")}
                onChange={this.props.updateSearchText}
                size={"large"}
                testId={"journal-postcreation-taglearningexperience"}
                focusSearchBySlash={true}
              />
            </div>
          )}
          <div
            className={classes.container}
            onScroll={this.handleScroll}
            ref={this.containerRef}
          >
            <ResourceList
              isLoading={isLoading}
              isData={isData}
              resources={resources}
              searchText={searchText}
              selectedUnitPlan={selectedUnitPlan}
              unitPlanOptionsLength={unitPlanOptionsLength}
              resourceId={resourceId}
              resourceType={resourceType}
              isResourceSkipped={isResourceSkipped}
              onResourceSkipClicked={this.skipResource}
              onItemClicked={this.onResourceClicked}
              showLoaderBar={false}
              curriculumProgramType={curriculumProgramType}
              networkStatus={networkStatus}
              resourceListRef={this.resourceListRef}
              selectLearningGoalsButton={this.selectLearningGoalsButton}
              tagLearningGoalsButton={this.tagLearningGoalsButton}
              postTaggedEntity={this.props.postTaggedEntity}
            />
          </div>
          {networkStatus == 3 ? (
            <Loading loadingStyle={{ width: 36, height: 36 }} />
          ) : null}
        </Modal.Body>
        <Modal.Footer style={styles.footerContainerStyle}>
          <div className={classes.footer}>
            <div className={classes.footerContainer}>
              <ConditionalWrapper
                type="wrapperAsElement"
                wrapper={
                  <Tooltip
                    tooltip={getTagLearningGoalsTooltip()}
                    placement={"top"}
                  />
                }
                condition={
                  !resourceId ||
                  !isTagLearningGoalsEnabled ||
                  !isAssessmentTagged(this.props.postTaggedEntity)
                }
              >
                <Button
                  type={!isTagLearningGoalsEnabled ? "fill" : "outlined"}
                  variant="neutral"
                  dsVersion="2.0"
                  disabled={!isTagLearningGoalsEnabled}
                  onClick={this.onNextClick}
                  size="medium"
                  testId="journal-postcreation-taglearninggoals"
                  ref={this.tagLearningGoalsButton}
                >
                  {t("journal:tag_pyp_elements")}
                </Button>
              </ConditionalWrapper>
              <Button
                variant={"progressive"}
                dsVersion="2.0"
                type="fill"
                size="medium"
                onClick={() => {
                  this.onNextClick(false);
                  isMagicWandClick &&
                    scrollIntoView({
                      element: document.getElementById("tagLearningElements"),
                      block: "end",
                      inline: "end",
                    });
                }}
                disabled={!resourceId}
                testId="journal-postcreation-selectresource"
                ref={this.selectLearningGoalsButton}
              >
                {t("common:select")}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapActionCreators = {
  updatePost,
  setToastMsg,
};

const groupType = ["LEARNING_ENGAGEMENT", "ASSESSMENT"];

const mapStateToProps = (state, ownProps) => {
  const organizationId = state.login.userInfo.org_id;

  const {
    unitPlan,
    resourceItem = {},
    resourceType,
    attachments,
    isResourceSkipped,
    elementPYP,
    courseUnitPlans = [],
    isMagicWandClick,
    courseId: postCourseId,
    postTaggedEntity,
  } = state.post.postDetails;

  const selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course"
  );
  const courseId =
    postCourseId ||
    selectedCourseId ||
    _.get(state, "post.postDetails.course.id", null);
  const dateOfToday = moment().format("YYYY-MM-DD");
  const currentAcademicYear = getCurrentAcademicYear({
    organizationId: organizationId,
  });
  const startDate = moment(_.get(currentAcademicYear, "startDate", "")).format(
    "YYYY-MM-DD"
  );
  const endDate = moment(_.get(currentAcademicYear, "endDate", "")).format(
    "YYYY-MM-DD"
  );

  const unitPlanOptions = _.map(courseUnitPlans, unit => {
    return {
      label: _.get(unit, "title.value", ""),
      value: _.get(unit, "id", undefined),
    };
  });

  const courseUnitPlansIds = _.map(courseUnitPlans, unit =>
    _.get(unit, "id", "")
  );

  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const uids = getFieldUids({ curriculumProgramType });

  return {
    startDate,
    endDate,
    mode: state.post.postCreationMode,
    unitPlanId: _.get(unitPlan, "id", ""),
    templateId: _.get(unitPlan, "templateId", ""),
    resourceId: _.get(
      getIsNewGoalTaggingEnabled() && isAssessmentTagged(postTaggedEntity)
        ? _.first(postTaggedEntity)
        : resourceItem,
      "id",
      ""
    ),
    resourceType,
    attachments,
    courseId,
    isResourceSkipped,
    elementPYP,
    showLoaderBar: false,
    resourceItem,
    curriculumProgramType,
    courseUnitPlansIds,
    courseUnitPlans,
    unitPlanOptions,
    searchText: _.get(ownProps, "searchText", ""),
    t: ownProps.t,
    organizationId: _.get(state, "login.userInfo.org_id"),
    uids,
    isMagicWandClick,
    postTaggedEntity,
  };
};

const TagResourceWithHOC = compose(
  connect(null, mapActionCreators),

  graphql(getOrganizationAssessmentsQuery, {
    name: "getOrganizationAssessments",
    skip: props => _.isEmpty(_.get(props, "organizationId", "")),
    options: ({
      organizationId,
      selectedUnitPlan,
      searchText,
      uids,
      courseId,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        first: ITEMS_TO_LOAD,
        id: organizationId,
        filters: {
          courseIds: [courseId],
          fetchDelinkedAssessment: true,
          searchText: searchText,
          types: groupType,
        },
        uids,
      },
    }),
    props: ({
      getOrganizationAssessments,
      ownProps: {
        resourceItem,
        organizationId,
        selectedUnitPlan,
        searchText,
        uids,
        courseId,
        postTaggedEntity,
      },
    }) => {
      const edges = _.get(
        getOrganizationAssessments,
        "node.assessments.edges",
        0
      );
      const leCount = _.get(
        getOrganizationAssessments,
        "node.assessments.totalCount",
        0
      );
      const assessmentCount = 0;
      const resources = _.map(edges, item => {
        return { type: "ASSESSMENT", ...item.node };
      });
      const selectedResourceItem = _.find(resources, {
        id: _.get(
          getIsNewGoalTaggingEnabled() && isAssessmentTagged(postTaggedEntity)
            ? _.first(postTaggedEntity)
            : resourceItem,
          "id"
        ),
      });
      return {
        hasNextPage: _.get(
          getOrganizationAssessments,
          "node.assessments.pageInfo.hasNextPage",
          false
        ),
        getOrganizationAssessments,
        leCount: leCount,
        assessmentCount: assessmentCount,
        resources: !_.isEmpty(selectedResourceItem)
          ? _.uniqBy([selectedResourceItem, ...resources], "id")
          : resources,
        isData: !!_.get(getOrganizationAssessments, "node", null),
        isLoading:
          getOrganizationAssessments["networkStatus"] == 1 ||
          getOrganizationAssessments["networkStatus"] == 2,
        networkStatus: getOrganizationAssessments["networkStatus"],
        loadMoreAssessments: () => {
          const endCursor = _.get(
            getOrganizationAssessments,
            "node.assessments.pageInfo.endCursor",
            false
          );
          return getOrganizationAssessments.fetchMore({
            variables: {
              first: 18,
              after: endCursor,
              id: organizationId,
              filters: {
                courseIds: [courseId],
                fetchDelinkedAssessment: true,
                searchText: searchText,
                types: groupType,
              },
              uids,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const previousAssessments = previousResult.node;
              const newAssessments = fetchMoreResult.node;
              return {
                ...previousResult,
                node: {
                  ...previousAssessments,
                  assessments: {
                    ...previousAssessments.assessments,
                    pageInfo: {
                      ...previousAssessments.assessments.pageInfo,
                      ...newAssessments.assessments.pageInfo,
                    },
                    edges: [
                      ..._.uniqBy(
                        [
                          ...previousAssessments.assessments.edges,
                          ...newAssessments.assessments.edges,
                        ],
                        item => _.get(item, "node.id")
                      ),
                    ],
                  },
                },
              };
            },
          });
        },
      };
    },
  })
)(TagResource);
class TagResourcesWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      selectedUnitPlan: _.get(props, "courseUnitPlansIds", ""),
    };
  }

  updateSearchText = value => {
    this.setState({ searchText: value });
  };

  onUnitPlanFilterChanged = value => {
    this.setState({ selectedUnitPlan: value });
  };

  render() {
    return (
      <TagResourceWithHOC
        {...this.props}
        searchText={this.state.searchText}
        updateSearchText={this.updateSearchText}
        selectedUnitPlan={this.state.selectedUnitPlan}
        onUnitPlanFilterChanged={this.onUnitPlanFilterChanged}
      />
    );
  }
}
export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, null)
)(TagResourcesWrapper);
